/**
 * Translates only the visible label of an existing cart line-item property.
 * The source key stays in data-source; values and production properties are never edited.
 */
class MyTometteCartPropertyLabel extends HTMLElement {
  static observedAttributes = ['data-source'];
  #observer;

  connectedCallback() {
    this.#observer ??= new MutationObserver(() => this.renderLabel());
    // Section morphing can restore the original text without replacing this element.
    // Observe only this label's own text, never the cart values or engraving content.
    this.#observer.observe(this, { childList: true, characterData: true, subtree: true });
    this.renderLabel();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  attributeChangedCallback() {
    if (this.isConnected) this.renderLabel();
  }

  renderLabel() {
    const source = this.getAttribute('data-source') || '';
    const translated = window.MT_CONFIG_I18N?.label(source) ?? source;
    if (this.textContent !== translated) this.textContent = translated;
  }
}

if (!customElements.get('mt-cart-property-label')) {
  customElements.define('mt-cart-property-label', MyTometteCartPropertyLabel);
}
